module.exports = __webpack_public_path__ + "/images/ico-vendedores-cesta.4cd24a8.svg";